import { httpPost } from "./httpService";

export function listEntityCategories(knowledgeGraphId, keywords) {
  return httpPost("/admin/entityCategory/v1/list", {
    knowledgeGraphId,
    keywords: keywords || undefined,
  });
}

export function createEntityCategory(knowledgeGraphId, code, name) {
  return httpPost("/admin/entityCategory/v1/create", {
    knowledgeGraphId,
    code,
    name,
  });
}

export function updateEntityCategoryName(id, name) {
  return httpPost("/admin/entityCategory/v1/updateName", { id, name });
}

export function updateEntityCategoryCode(id, code) {
  return httpPost("/admin/entityCategory/v1/updateCode", { id, code });
}

export function deleteEntityCategory(id) {
  return httpPost("/admin/entityCategory/v1/delete", { id });
}
